/**
 * Formatter to format numbers for currency.
 */
export const formatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
});
